/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import cx from 'classnames';
import s from './../../directives/HamburgerMenu/hamburgerMenu.module.css';
import { retailerSettingsService } from '../../services/retailer-settings/retailer-settings';

const HamburgerMenu = () => {
  const [displayNav, setDisplayNav] = React.useState(false);
  const nav = retailerSettingsService.getNav();
  const header = retailerSettingsService.getHeader();

  const toggleHamburger = () => setDisplayNav((currentValue) => !currentValue);

  return (
    <>
      <div className={cx('hamburger-menu header_nav', s.hamburger_menu)}>
        <div className={cx('hamburger-container', s.hamburger_container)}>
          <div className={cx('hamburger-display', s.hamburger_display)}>
            {nav?.length ? (
              <button className={cx('hamburger-icon', s.hamburger_icon)} onClick={toggleHamburger}>
                <i className="fa fa-bars" />
              </button>
            ) : null}
            <div>
              <a
                className="hamburger-retailer-logo-link"
                href={`${header.target_url || ''}${header.return_tid || ''}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className={cx('hamburger-retailer-logo', s.hamburger_retailer_logo)}
                  src={header.desktop_src_2x}
                  alt={header.alt_text}
                />
              </a>
            </div>
          </div>
          <div
            className={cx('hamburger-dropdown-list', s.hamburger_dropdown_list)}
            style={{ display: displayNav ? 'block' : 'none' }}
          >
            <ul className={cx('hamburger-list', s.hamburger_list)}>
              {nav.map((item, index) => (
                <li
                  key={index}
                  className={cx(
                    'nav-item',
                    `nav-${item.label.toLowerCase()}`,
                    'hamburger-item',
                    s.hamburger_item,
                  )}
                >
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cx(
                      item.label.toLowerCase(),
                      'hamburger-menu-item',
                      s.hamburger_menu_item,
                      `hamburger-menu-item-${index}`,
                    )}
                    href={`${item.href || ''}${item.return_tid || ''}`}
                    data-track={item.tracking_id}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div
        className={cx('overlay', s.overlay)}
        role="button"
        onClick={() => setDisplayNav(false)}
        style={{ display: displayNav ? 'block' : 'none' }}
      />
    </>
  );
};

export default HamburgerMenu;
